import { httpV1 as http } from '../api';

const CONTEXT = '/bms/fgts';

export async function consult(params) {
  return http.get(`${CONTEXT}/balance`, { params });
}

export async function simulation(data) {
  return http.post(`${CONTEXT}/simulation`, data);
}

export async function approve(data) {
  return http.post(`${CONTEXT}/credit-operation`, data);
}

export async function verify(params) {
  return http.get(`${CONTEXT}/proposal`, { params });
}

export async function cancel(data) {
  return http.post(`${CONTEXT}/cancel`, data);
}

export async function receipt(id, params) {
  return http.get(`/bms/fgts/reserve_balance/${id}/generate_receipt`, { params });
}

export async function tryAgain(data) {
  return http.put(`${CONTEXT}/credit-operation`, data);
}
